import React from 'react';
import t from 'prop-types'; //import Draggable, { DraggableCore } from 'react-draggable'

import VentanaFlotante from './ventana-flotante';
import VentanaEstatica from './ventana-estatica';

function VentanaSimple(props) {
  if (props.flotante) {
    return React.createElement(VentanaFlotante, props);
  }

  return React.createElement(VentanaEstatica, props);
}

VentanaSimple.propTypes = process.env.NODE_ENV !== "production" ? {
  clases: t.string,
  tieneAnimacion: t.bool.isRequired,
  flotante: t.bool.isRequired,
  ancho: t.oneOfType([t.string, t.number]),
  // opcional
  alto: t.oneOfType([t.string, t.number]),
  // opcional
  abierta: t.bool,
  onResize: t.func,
  id: t.string,
  children: t.any,
  ajusteInicial: t.string
} : {};
export default VentanaSimple;